import {searchOrFallback} from "./globals.ts";

const copyrightYear: string = '2026'
const defaultSlogan = '下一站，海阔天空✨'

function removePrefix(s: string, prefix: string) {
    return s.startsWith(prefix) ? s.slice(prefix.length) : s
}

function putCopyright() {
    const copyrightText = document.getElementById('copyright-text')

    const hostname = removePrefix(window.location.hostname, 'www.')
    if (copyrightText) copyrightText.textContent = `\u00a9${copyrightYear} ${hostname} 版权所有`

    const miniSloganElement = document.getElementById('mini-slogan')
    if (miniSloganElement) miniSloganElement.textContent = searchOrFallback('mini-slogan', defaultSlogan)
}

putCopyright()